import React, { useContext } from "react";
import { Draggable } from "react-beautiful-dnd";

//MUI 
import {
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemButton
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";


//MUI Icons
import { Delete, Inbox, Menu } from "@mui/icons-material";

// import { Item } from "../typings";
// import { Item } from "./DraggableList";
import { RoutePoint } from "../PublicPage/SidebarPanes/PublicRoutesPane";

//Open Layers
import OlPoint from "ol/geom/Point";

//Custom Components
import MapContext from "@/components/Map/MapContext";

//Types
import { DCRecord } from "@/@types/lib/dataController";

const styles = {
  draggingListItem: {
    background: "rgb(235,235,235)",
  },
};

export type DraggableListItemProps = {
  // TODO use generic type instead of RoutePoint
  item: RoutePoint;
  index: number;
  handleDeleteItem: (indexToDelete: number) => void;
};

const DraggableListItem = ({ item, index, handleDeleteItem }: DraggableListItemProps) => {

  const mapContext = useContext(MapContext);

  const theme = useTheme();
  const isMobile: boolean = useMediaQuery(theme.breakpoints.down("md"));

  const handleExplore = (evt: React.MouseEvent<HTMLDivElement> | null, item: DCRecord) => {
    const coord = item["coord"] as number[];
    if (coord) {
      const p = new OlPoint(coord);

      if (mapContext && mapContext.map) {
        const view = mapContext.map.getView();
        const extent = p.getExtent();

        const padding = isMobile ? [20, 20, 300, 20] : [20, 20, 20, 20]
        if (extent)
          view.fit(extent, { padding: padding, duration: 500, maxZoom: 15 });
      }
    }
  }

  return (
    <Draggable draggableId={item.uuid} index={index}>
      {(provided, snapshot) => (
        <ListItemButton
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          sx={snapshot.isDragging ? styles.draggingListItem : { px: 0}}
          onClick={(evt) => handleExplore(evt, item)}
        >
          <ListItemAvatar>
            <Avatar sx={{ width: 28, height: 28, bgcolor: "primary.main", fontSize: "16px" }}>{index + 1}</Avatar>
          </ListItemAvatar>
          <ListItemText primary={item.label} />
          <Menu />
          <IconButton
            onClick={(evt) => {
              handleDeleteItem(index)
              evt.stopPropagation()
            }}
          >
            <Delete />
          </IconButton>
        </ListItemButton>
      )}
    </Draggable>
  );
};

export default DraggableListItem;
